import contract from '@mailobj-browser/front/js/contracts/contract.js'
import add from './add/add.js'
import item from './item/item.js'

export default contract({
  add,
  item
})